import * as Localization from 'expo-localization'
import type { ModuleType } from 'i18next'

const type: ModuleType = 'languageDetector'
const languageDetector = {
  type,
  detect: () => {
    try {
      const locales = Localization.getLocales()
      return locales?.[0]?.languageCode || 'en'
    } catch (error) {
      console.warn('Failed to detect locale:', error)
      return 'en'
    }
  },
  init: () => {},
  cacheUserLanguage: () => {},
}

export default languageDetector
